import { render, staticRenderFns } from "./mirbuilderv1.vue?vue&type=template&id=dc7dc2f2&"
import script from "./mirbuilderv1.vue?vue&type=script&lang=ts&"
export * from "./mirbuilderv1.vue?vue&type=script&lang=ts&"
import style0 from "./mirbuilderv1.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports